var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close-Fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1144",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM7.46933 16.4696C7.76222 16.7625 8.23709 16.7625 8.52999 16.4696L11.9996 13L15.4698 16.4701C15.7627 16.763 16.2376 16.763 16.5304 16.4701C16.8233 16.1772 16.8233 15.7024 16.5304 15.4095L13.0603 11.9393L16.4698 8.52981C16.7627 8.23692 16.7627 7.76205 16.4698 7.46915C16.1769 7.17626 15.702 7.17626 15.4091 7.46915L11.9996 10.8787L8.59065 7.46967C8.29775 7.17678 7.82288 7.17678 7.52999 7.46967C7.23709 7.76257 7.23709 8.23744 7.52999 8.53033L10.939 11.9393L7.46933 15.409C7.17643 15.7018 7.17643 16.1767 7.46933 16.4696Z",
    fill: "#CFD4D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/delete-item.2b889dc983119476d7ed9104dff91127.svg";
export { ForwardRef as ReactComponent };